/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect, useRef } from 'react';
import DismantlerLayout from "../../layouts/DismantlerLayout";
import {Link, useParams} from "react-router-dom";
import ListingTop from "../../components/ListingTop";
import ListingBottom from "../../components/ListingBottom";
import FiltersCars from "../../components/FiltersCars";
import CarBoxDesmantler from "../../components/CarBoxDesmantler";
import axios from "axios";
import Loader from "../../elements/loader";
import { useOutletContext } from "react-router-dom";
import FilterCheckbox from "../../elements/FilterCheckbox";
import CarBox from "../../components/CarBox";
import {getDismantler} from "../../Hooks/DesmantlerData";
import useAxiosJTW from "../../Hooks/useAxiosJTW";

const DismantlerCars = () => {

    let params = useParams();
    const scrollTop = useRef(null);

    const isInitialSort = useRef(true);

    const axiosJWT = useAxiosJTW();
    const controller = new AbortController();
    const signal= controller.signal;

    const [dataToSend, setDataToSend] = useState({
        page : 1,
        has_ads: '1',
        sort: 'date-desc',
        merchantid: params.merchantid,
        criteria: [],
        make_id: '',
        model: '',
        year: '',
        fuel: '',
        city: '',
        limit: 50
    });


    const [ads, setAds] = useState([]);
    const [criteria, setCriteria] = useState([]);

    const [sortValue, setSortValue] = useState('date-desc');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const [outletData, setOutletData] = useOutletContext();
    const [isLoading, setIsLoading] = useState(true);
    const [filterLoading, setFilterLoading] = useState(true);


    const getcarsbymerchantid = (dataToSend, signal) => {
        axiosJWT.post('api/getcarsbymerchantid', dataToSend, {signal}).then( (response) => {
            if(response.status === 200){

                setAds(response.data.ads || []);

                if( response.data.criteria ){
                    setCriteria(response.data.criteria);
                }

                const dismantler = getDismantler(response.data.merchant_info, response.data.schedule);
                setOutletData(dismantler);

                setTotalPages( parseInt(response.data.total_pages) || 1 );
                setTotalItems(  parseInt(response.data.total_ads) );

                setIsLoading(false);
                setFilterLoading(false);

            }
        } ).catch((error) => {
            console.log(error);
        });

    }

    useEffect(() => {
        setIsLoading(true);

        getcarsbymerchantid( dataToSend, signal);

        return () => {controller.abort();}
    }, [dataToSend]);

    useEffect(() => {
        if (isInitialSort.current) {
            isInitialSort.current = false;
        } else {
            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                sort: sortValue
            }));
        }
        return () => {controller.abort();}
    }, [sortValue]);

    function onSubmitFilters(value){
        setDataToSend(prevState => ({
            ...prevState,
            page: 1,
            make_id: value.make_id,
            model: value.model_name,
            year: value.years,
            fuel: value.fuel,
            city: value.city
        }));
    }

    function onResetFilters(){
        setDataToSend(prevState => ({
            ...prevState,
            page: 1,
            make_id: '',
            model: '',
            year: '',
            fuel: '',
            city: ''
        }));
    }

    return (
        // <DismantlerLayout>
            <div ref={scrollTop} className='page-row'>
                <div className='page-sidebar'>

                    {filterLoading ? (
                        <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                    ) : (
                        <>
                            <FiltersCars
                                isDismantler={true}
                                onReset={onResetFilters}
                                onSubmit={onSubmitFilters}
                            />

                            <div className='pt-5'>
                                {
                                    criteria.map( (item, index) => (
                                        <FilterCheckbox selected={dataToSend.criteria} onSelect={setDataToSend} filter={item} key={index}/>
                                    ) )
                                }
                            </div>
                        </>
                    )}

                </div>
                <div className='page-content'>

                    <ListingTop onSort={setSortValue} value={sortValue} count={totalItems}/>

                    <div className='carBoxs'>

                        {isLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        ) : (
                            ads.map((item, index) => {
                                return(
                                    // <CarBoxDesmantler key={index} ad={ads[key]}/>
                                    <CarBox key={index} ad={item}/>
                                );
                            })
                        )}

                    </div>

                    <ListingBottom currentPage={dataToSend.page} totalPages={totalPages} onChangePage={setDataToSend} scrollTop={scrollTop} green={true}/>
                </div>
            </div>
        // </DismantlerLayout>
    );
};

export default DismantlerCars;
